export default __webpack_public_path__ + "static/media/image.dotcom-systems-private-limited.f6cf6001.png";